import { Injectable } from '@angular/core';
import { RevokeOrderFormData } from './revokeOrder.facade';
import { CircularInjectionHelper } from '../../services/circularInjectionHelper';

/** Reactive form and HTTP delegation for the revoke-order page. */
@Injectable()
export class RevokeOrderService {

  constructor(
    private _injHelper: CircularInjectionHelper,
  ) { }

  /**
   * Trims string values and delegates to YourAppServerApi.SubmitRevokeOrder.
   * Resolves with the server success flag; rejects on HTTP error or network failure.
   */
  public submitRevokeOrder(formData: RevokeOrderFormData): Promise<boolean> {
    const me = this;
    return me._injHelper.yourAppServer.Api.SubmitRevokeOrder({
      name: formData.name.trim(),
      email: formData.email.trim(),
      order_number: formData.orderNumber.trim(),
      articles: formData.articles ? formData.articles.trim() : null,
      reason: formData.reason ? formData.reason.trim() : null,
    });
  }
}
